/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'loader-button',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './loaderButton.component.html',
  styleUrl: './loaderButton.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderButtonComponent {}
